import React from 'react'
import { Collapse } from 'antd'

import { RequestQuoteAirGroup } from 'src/types'

import { WrapCollapsePanel, WrapRow } from './styles'
import InfoItemHistory from './info-item-history'
import HeaderItemHistory from './header-item-history'

function SearchResultItemHistory({
  journeys
}: {
  journeys: RequestQuoteAirGroup[]
}) {
  return (
    <Collapse bordered={false} destroyInactivePanel>
      {journeys.map(
        ({ request_quote_airs }: RequestQuoteAirGroup, index: number) => {
          const hasChosen = request_quote_airs.some(({ chosen }) => chosen)
          return (
            <WrapCollapsePanel
              header={<HeaderItemHistory item={request_quote_airs} />}
              highlight={hasChosen}
              key={`${index}`}
            >
              <WrapRow>
                {request_quote_airs[0].request_quote_air_flights.map(
                  (flightItem, index) => (
                    <InfoItemHistory item={flightItem} key={index} />
                  )
                )}
              </WrapRow>
            </WrapCollapsePanel>
          )
        }
      )}
    </Collapse>
  )
}

export default SearchResultItemHistory
